import { CohortIntensity } from "../../../../models/CohortIntensity";
import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const createCohort = (
  language: string,
  payload: {
    customer_type: string;
    description: string;
    dt_end: string;
    dt_end_planned?: string;
    dt_start?: string;
    intensity: CohortIntensity;
    language: string;
    leader_id: number;
    logo?: string;
    name: string;
    need_project?: boolean;
    program_manager_id?: number;
    school: number;
  },
  onSuccess?: Function,
  onError?: Function
) => {
  return ApiService.post("cohorts", payload)
    .then((resp) => onSuccess?.(resp.data))
    .catch((error) => {
      console.error("An error occurred during cohort creation", error);
      alert(translate(language, "PAGES.COHORTS.ERRORS.CREATION"));
      onError?.(error);
    });
};
